import { FormattedMessage } from 'react-intl';

import styles from './TruelayerConfirmation.module.css';
import messages from '../../modals/manualPaymentModal/ManualPaymentModal.messages';
import DashboardLink from '../../navigation/DashboardLink';
import { LoadingSpinner } from '../../ui/loadingSpinner';
import { Prompt } from '../../ui/prompt';

export const PaymentProcessing = () => (
    <>
        <div className={styles.confirmationContainer}>
            <div
                className={styles.primaryContent}
                data-testid="message-container"
            >
                <div className={styles.title}>You're all done!</div>
                <p>We are processing your payment</p>
            </div>
            <div className={styles.spinnerContainer}>
                <LoadingSpinner className={styles.loadingSpinner} />
            </div>
        </div>
        <Prompt className={styles.prompt}>
            <DashboardLink>
                <FormattedMessage {...messages.returnToDashboard} />
            </DashboardLink>
        </Prompt>
    </>
);
